import type { ReactNode } from "react";

import "./PageHeader.css";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  return (
    <header className="bmd-page-header">
      <div>
        <h1 className="bmd-page-title">{title}</h1>
        {subtitle && <p className="bmd-page-subtitle">{subtitle}</p>}
      </div>
      {action && <div className="bmd-page-action">{action}</div>}
    </header>
  );
}
